import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('errors.notFound.title')}
        description={t('errors.notFound.description')}
        type="website"
      />
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
            textAlign: 'center',
            py: 8
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: '6rem', sm: '8rem' },
              fontWeight: 'bold',
              color: 'primary.main',
              mb: 2
            }}
          >
            404
          </Typography>
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            sx={{
              mb: 3,
              fontFamily: '"Playfair Display", serif'
            }}
          >
            {t('errors.notFound.title')}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            paragraph
            sx={{ mb: 4, maxWidth: '600px' }}
          >
            {t('errors.notFound.description')}
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.1rem'
            }}
          >
            {t('errors.notFound.backToHome')}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default NotFound; 